<template>
  <div class="reels-downloader-page">
    <HeadNav page="instasave" />
    <!-- <Breadcrumb routeName="reels-downloader" /> -->
    
    <!-- Hero Section -->
    <HeroSection 
      :title="heroTitle"
      :subtitle="heroSubtitle"
      :inputPlaceholder="inputPlaceholder"
      :activeTab="activeTab"
      @tab-change="switchTab"
      @download-content="downloadContent"
      @go-to-download="goToDownload"
      @join-telegram="joinTelegramChannel"
    />

    <div class="home-wrapper">
      <!-- Introduction Section -->
      <section class="introduction-section">
      <div class="container">
        <div class="intro-content">
          <h2 class="section-title">Download IG Reel by Link in HD</h2>
          <p class="section-description">
            Easily download Instagram (IG) Reels by link in high definition (HD). Our tool lets you save Reels quickly and securely, with no login required. Enjoy fast, high-quality downloads on any device.
          </p>
        </div>
        <div class="intro-image">
          <img :src="require('@/assets/reels/reel1.webp')" alt="Download Instagram Reels" />
        </div>
      </div>
    </section>

    <!-- How to Section -->
    <HowToSection 
      :title="howToTitle"
      :steps="howToSteps"
    />

    <!-- App Recommendation Section -->
    <AppRecommendationSection 
      :title="appRecommendationTitle"
      :description="appRecommendationDescription"
      :buttonText="appRecommendationButtonText"
      :imageSrc="appRecommendationImageSrc"
      :imageAlt="appRecommendationImageAlt"
      :showImage="true"
      @go-to-download="goToDownload"
    />

    <h2 class="left-title">Features of Instagram Reels Downloader</h2>

    <!-- Features Section -->
    <FeaturesGrid :features="features" />

    <!-- FAQ Section -->
    <section class="faq-section">
      <div class="container">
        <h2 class="section-title">FAQs</h2>
        <div class="faq-list">
          <div 
            v-for="(faq, index) in faqs" 
            :key="index" 
            class="faq-item"
            :class="{ 'expanded': expandedFaqs.includes(index) }"
          >
            <div class="faq-question" @click="toggleFaq(index)">
              <h3>{{ faq.question }}</h3>
              <span class="faq-icon">{{ expandedFaqs.includes(index) ? '−' : '+' }}</span>
            </div>
            <div class="faq-answer" v-if="expandedFaqs.includes(index)">
              <p>{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    </div>
  </div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import HeroSection from '@/components/HeroSection.vue'
import AppRecommendationSection from '@/components/AppRecommendationSection.vue'
import HowToSection from '@/components/HowToSection.vue'
import FeaturesGrid from '@/components/FeaturesGrid.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'ReelsDownloader',
  components: {
    HeadNav,
    Breadcrumb,
    HeroSection,
    AppRecommendationSection,
    HowToSection,
    FeaturesGrid,
    Footer
  },
  head() {
    return {
      title: 'Instagram Reels Downloader',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Instagram Reels videos Downloader in high quality—Full HD, 1080p, 2K, and 4K, using either our online tool or the InstaSave app for a faster, one-click method to Download Instagram Reels.'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'instagram reels downloader, download instagram reels, instagram reels download, reels downloader'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://instasaves.io/reels-downloader/'
        }
      ]
    }
  },
  data() {
    return {
      pageName: 'reels-downloader',
      instagramLink: '',
      expandedFaqs: [],
      activeTab: 'reels',
      heroTitle: 'Instagram Reels Downloader',
      heroSubtitle: 'Download Instagram Reels videos in high quality—Full HD, 1080p, 2K, and 4K—quickly and easily.',
      inputPlaceholder: 'Paste Instagram Reels link here',
      howToTitle: 'Download Instagram Reels Guide',
      howToSteps: [
        {
          title: 'How to Download Instagram Reels Online',
          items: [
            {
              title: 'Step 1: Copy the Reels Link',
              content: [
                'Open Instagram and copy the Reels video link.'
              ]
            },
            {
              title: 'Step 2: Paste the Link',
              content: [
                'Paste the link into our Instagram Reels Downloader online tool.'
              ]
            },
            {
              title: 'Step 3: Download',
              content: [
                'Click Download to save the video instantly in high quality.'
              ]
            }
          ]
        },
        {
          title: 'How to Download Reels Using InstaSave App',
          items: [
            {
              title: 'Download and Install',
              content: [
                'Download and install the <a href="https://instasaves.io/instagram-apk-downlad/" target="_blank">InstaSave APK</a>.',
                'Open the app and paste the Instagram Reels link.',
                'Tap Download to save the video directly to your device.'
              ]
            }
          ]
        }
      ],
      appRecommendationTitle: 'Download InstaSave App APK',
      appRecommendationDescription: 'Download our <a href="https://instasaves.io/instagram-apk-downlad/" class="jump-url" target="_blank">InstaSave App</a> and start using it directly within the app, Our app delivers fast, high-quality downloads without watermarks, making it the perfect tool to save Instagram stories effortlessly.',
      appRecommendationButtonText: 'Install Now',
      appRecommendationImageSrc: require('@/assets/reels/reel2.webp'),
      appRecommendationImageAlt: 'InstaSave App',
      features: [
        {
          title: "High-Quality Downloads",
          description: "Save Instagram Reels in Full HD, 1080p, 2K, or even 4K without losing resolution, ensuring the best viewing experience on any device.",
          imageSrc: require('@/assets/reels/reel3.webp'),
          imageAlt: "High-Quality Downloads"
        },
        {
          title: "Fast & Easy",
          description: "Download Instagram Reels instantly with just a link—no complicated steps, no extra apps needed. Simply paste the URL and get your video saved in seconds.",
          imageSrc: require('@/assets/reels/reel4.webp'),
          imageAlt: "Fast & Easy"
        },
        {
          title: "No Sign-Up Required",
          description: "Start downloading Instagram Reels right away without creating an account or sharing personal details—completely hassle-free.",
          imageSrc: require('@/assets/reels/reel5.webp'),
          imageAlt: "No Sign-Up Required"
        },
        {
          title: "Online & App Methods",
          description: "Use our online tool on any device or the InstaSave app for faster, one-click downloads.",
          imageSrc: require('@/assets/reels/reel6.webp'),
          imageAlt: "Online & App Methods"
        }
      ],
      faqs: [
        {
          question: "Can I download Instagram Reels without watermark?",
          answer: "Absolutely! Our tool provides Instagram Reels download without watermark, so you get clean, high-quality videos."
        },
        {
          question: "Does Instagram Reels Downloader work on iPhone?",
          answer: "Yes. The online Instagram Reels Downloader works on iPhone, iPad, and desktop browsers. The APK app is for Android users only."
        },
        {
          question: "How do I download Instagram Reels with audio?",
          answer: "Simply paste the link into our downloader, and the video will be saved with original audio in high quality."
        },
        {
          question: "Is it safe to download Instagram Reels online?",
          answer: "Yes. Our safe Instagram Reels Downloader doesn't require login or personal details, making it secure to use."
        },
        {
          question: "Can I download private Instagram Reels?",
          answer: "No. You can only download Reels from public accounts or accounts you follow."
        },
        {
          question: "What resolutions are supported for Reels download?",
          answer: "Our downloader supports HD, 1080p, 2K, and 4K video quality for Instagram Reels."
        }
      ]
    }
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab
      console.log('Switching to tab:', tab)
    },
    downloadContent() {
      // Handle download logic
      console.log('Download content:', this.instagramLink)
    },
    goToDownload() {
      this.$router.push('/instagram-apk-downlad/')
    },
    joinTelegramChannel() {
      window.open('https://t.me/+M75kow80SlQ1MjZl', '_blank')
    },
    toggleFaq(index) {
      const expandedIndex = this.expandedFaqs.indexOf(index)
      if (expandedIndex > -1) {
        this.expandedFaqs.splice(expandedIndex, 1)
      } else {
        this.expandedFaqs.push(index)
      }
    }
  }
}
</script>

<style scoped>

.home-wrapper {
  max-width: 1000px;
  margin: 0 auto;
  margin-top: 1rem;
}

.left-title{
    width:1200px;
    margin: 0 auto;
    padding-left: 20px;
    padding-top: 80px;
    text-align: center;
    @media (max-width: 768px) {
    width: 100%;
    padding-left: 0;
  }
}

.reels-downloader-page {
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.introduction-section {
  padding: 80px 0;
  background: white;
}

.introduction-section .container {
  display: flex;
  align-items: center;
  gap: 60px;
}

.intro-content {
  flex: 1;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 30px;
  line-height: 1.2;
}

.section-description {
  text-align: left;
  font-size: 1.2rem;
  line-height: 1.6;
  color: #666;
  margin: 0;
}

.intro-image {
  flex: 0.5;
  text-align: center;
}

.intro-image img {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.faq-section {
  padding: 80px 0;
  background: #f8f9fa;
}

.faq-list {
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  background: white;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.faq-item:hover {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.faq-question {
  padding: 25px 30px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  transition: all 0.3s ease;
}

.faq-question:hover {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
}

.faq-question h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin: 0;
  flex: 1;
}

.faq-icon {
  font-size: 1.5rem;
  font-weight: bold;
  color: #667eea;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.faq-item.expanded .faq-icon {
  background: #667eea;
  color: white;
  transform: rotate(180deg);
}

.faq-answer {
  padding: 0 30px 25px;
  background: white;
}

.faq-answer p {
  font-size: 1rem;
  line-height: 1.6;
  color: #666;
  margin: 0;
}

@media (max-width: 768px) {
  .introduction-section .container {
    flex-direction: column-reverse;
    gap: 40px;
  }
  
  .section-title {
    font-size: 2rem;
    margin-bottom: 20px;
    text-align: center;
  }
  
  .section-description {
    font-size: 1.1rem;
    text-align: center;
  }
  
  .faq-question {
    padding: 20px;
  }
  
  .faq-question h3 {
    font-size: 1.1rem;
  }
  
  .faq-answer {
    padding: 0 20px 20px;
  }
  
  .faq-icon {
    width: 25px;
    height: 25px;
    font-size: 1.2rem;
  }
}
</style>
